export default __webpack_public_path__ + "29cb1a8692ce15de3722bca7769921a6.png";